import React, { Context, createContext, useContext, useState } from "react";

interface ISideBar {
  open: boolean;
  setOpen: (...args) => any;
}

export const SideBarContext: Context<ISideBar> = createContext({
  open: null,
  setOpen: () => {},
});

export default function SideBarContextProvider(props) {
  const [open, setOpen] = useState(false);
  return (
    <SideBarContext.Provider value={{ open, setOpen }}>
      {props.children}
    </SideBarContext.Provider>
  );
}

export const useSideBarContext = () => useContext(SideBarContext);
